function Experience() {
  return (
    <div className="experience-container" id="experience">
      <div className="experience-info">
        <div className="experience-title">
          <h1>Experience</h1>
        </div>
    <div class="row row-cols-1 row-cols-md-3 g-4">
  <div class="col">
    <div class="card text-center">
      <div class="card-body experience-info">
        <h3 class="card-title">General Assembly - London</h3>
        <h6 className="experience-job-title card-subtitle mb-2 text-muted">
              Student
        </h6>
        <h6 className="experience-dates card-subtitle mb-2 text-muted">
              Oct'21 - Jan'22
        </h6>
        <ul className="experience-responsibilities card-text">
            <li>
            Group-based weeklong projects building applications, gained cooperative skills working in teams as well as project managing in an agile environment.
            </li>
            <li>
            Learnt fundamentals of JavaScript, HTML, CSS, Python as well as SQL and MongoDB.
            </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="col">
    <div class="card text-center">
      
      <div class="card-body">
        <h3 class="card-title">Department for Business, Energy & Industrial Strategy - London </h3>
        <h6 className="experience-job-title card-subtitle mb-2 text-muted">
            Advisor
          </h6>
          <h6 className="experience-dates card-subtitle mb-2 text-muted">
            Sept'19-Present
          </h6>
          <ul className="experience-responsibilities card-text">
            <li>Collaborated with analysts, consultants and other government departments, essential support in developing detailed policy positions on climate ambition mandates in Free Trade Agreements.</li>
            <li>Increased stakeholder engagement levels and positive feedback through active relationship management.</li>
            <li>Conducting thorough analysis to determine the feasibility of negotiation actions being undertaken by the team, providing new feasible solutions and subsequently getting sign-off.</li>
            <li>Drove innovation on presentation of policy priorities to maximise media coverage on such topics by presenting complex and varied information in a straightforward and engaging manner.</li>
            <li>Oversaw project timelines, delivered key milestones, maintained project scopes and ensured timely and successful completion of milestones.</li>
          </ul>
      </div>
    </div>
  </div>
  <div class="col">
    <div class="card text-center">
      <div class="card-body">
        <h3 class="card-title">Transport for London - London </h3>
        <h6 className="experience-job-title card-subtitle mb-2 text-muted">
              Performance Information Analyst
        </h6>
        <h6 className="experience-dates card-subtitle mb-2 text-muted">
              March’19 - Sept’19
        </h6>
        <ul className="experience-responsibilities card-text">
                <li>Collaborated with multi-disciplinary teams, providing specialist information, analytical support and business intelligence to TfL to help drive business operations.</li>
                <li>Collated data and delivered regular reports and analysis to the business, board members and stakeholders on health and safety issues.</li>
                <li>Identified and gathered business requirements to analyse and assess the priorities with the purpose of presenting back to senior management the best viable solution.</li>
                <li>Engaged in key decision making and the achieving of business objectives by providing management information and analysis to stakeholders.</li>
                <li>Collaborated with the team to regularly review the accuracy of performance and safety information, solving data quality issues and feeding back any errors.</li>
        </ul>
      </div>
    </div>
  </div>
</div>
</div>
</div>
  );
}

export default Experience;
